<div class="container main-container">

  <!--==============Main Middle Start==============-->
  <div class="main-middle">
      <!--............Start stories..............-->
      <div class="thumbnail-slider">
          <div class="nav-arrow left" (click)="scrollLeft()">&#10094;</div>
        
          <div class="thumbnail-container" #sliderContainer>
            <!-- Bouton pour ajouter une nouvelle story -->
            <div class="thumbnail add-story-btn" (click)="openCreateStoryModal()">
              <div class="story-cover add-story-cover">
                <i class="fas fa-plus"></i>
                <p>Ajouter <br> une story</p>
              </div>
            </div>
  
            <!-- Bouton pour ajouter une story -->
      
        
            <!-- Liste des utilisateurs avec leurs stories -->
            <div
              *ngFor="let user of users0"
              class="thumbnail"
              (click)="openStory(user)"
            >
              <div class="story-cover">
                <img [src]="(user.stories?.length > 0 ? (getLatestStory(user.stories)?.url || '/assets/default-story-cover.png') : '/assets/default-story-cover.png')"
                     [ngStyle]="{'opacity': user.stories?.length > 0 ? 1 : 0.7}"
                     alt="Story Cover" 
                     class="cover-image"
                     (error)="$event.target.src = '/assets/default-story-cover.png'" />
                <div class="overlay">
                  <img [src]="user.profilePhotoUrl || 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" 
                       [routerLink]="['/postfeed/userprofile', user.uid]" 
                       alt="Profile Picture" 
                       class="profile-picture"
                       (error)="$event.target.src = 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" />
                  <p>{{ user.publicName }}</p>
                </div>
              </div>
            </div>
          </div>
        
          <div class="nav-arrow right" (click)="scrollRight()">&#10095;</div>
        </div>
        
        <!-- Fenêtre modale pour créer une nouvelle story -->
          <div *ngIf="isCreateStoryModalOpen" class="modal">
              <div class="modal-content">
              <!-- Bouton de fermeture -->
              <span class="close" (click)="closeCreateStoryModal()">&times;</span>
              
              <!-- Titre -->
              <h2 class="modal-title">Ajouter une story</h2>
              
              <!-- Input pour sélectionner l'image -->
              <div class="upload-section">
                  <label for="file-upload" class="custom-file-upload">
                  Sélectionnez une image
                  </label>
                  <input id="file-upload" type="file" (change)="onFileSelected($event)" accept="image/*" />
              </div>
              
              <!-- Aperçu de l'image -->
              <div *ngIf="selectedImageFile" class="image-preview-section">
                  <h3>Aperçu:</h3>
                  <img [src]="selectedImageFile" class="preview-image" />
              </div>
              
              <!-- Bouton publier -->
              <button class="publish-button" (click)="publishStory()">Publier</button>
              </div>
          </div>
    
        
        <app-story-viewer *ngIf="isStoryOpen" [stories]="currentUserStories" [currentUser]="currentStoryUser" [isOpen]="isStoryOpen" (close)="closeStory()"></app-story-viewer>
        
      <br>
      
      <!--............End stories..............-->
  
      <!--............Post Input..............-->
      <div class="container0">
          <div class="row create-post-card">
              <form action="" class="add-post">
                  <div class="add-post-row" (click)="onCreatePostClick()">
                      <div class="profile-picture " id="my-profile-picture">
                          <img [src]="profilePhotoUrl" alt="">
                      </div>
                      <div class="publier">Publiez une photo sonore...</div>
                      <div class="post-actions">
                          <button class="action-btn photo-btn">
                              <mat-icon>image</mat-icon>
                          </button>
                          <button class="record-btn" [class.pulse]="isHovered">
                              <mat-icon>mic</mat-icon>
                          </button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
  
  
      
      
      
      <!--............Post Input..............-->
      <br>
  
      <div >
          <div id="post-feed">
              
              <app-post *ngFor="let post of posts" 
              [postData]="post"
              (videoPlayed)="onVideoPlay($event)"
              (audioPlayed)="onAudioPlay($event)"
              (messageUser)="openChatWindow($event)"
              (chatSelected)="openChatBottomSheet($event)">
              </app-post>
          </div>
  
          <!-- Indicateur de chargement -->
          <div  class="loading-container">
            <div  class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </div>
          <!-- Ajoutez cet élément ici -->
          <div #loadMoreTrigger id="load-more-trigger"></div>
      </div>
      
  </div>
  <!--==============Main Middle End==============-->
  
  <!--==============Main Right Start==============-->
  <div class="main-right">
      <div class="messages">
          <div *ngIf="suggestedFriends.length>0" class="discussion-instantane">
              <h5>Suggestion de contact...</h5> 
              <div class="suggestion-container">
                <div class="suggestion-list">
                  <div class="suggestion-card" *ngFor="let user of suggestedFriends"> 
                    <div class="suggestion-card-header">
                      <button class="close-btn" (click)="removeSuggestion(user.id)">&times;</button>
                    </div>
                    <div class="suggestion-content">
                      <img [src]="user.profilePhotoUrl ? user.profilePhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" alt="Photo de profil" class="profile-img" [routerLink]="['/postfeed/userprofile', user.uid]" />
                      <p class="user-name">{{ user.publicName }}</p>
                      <button class="follow-btn" (click)="followUser(user.id)">Suivre</button>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
     
      <br>
      <div class="firend-request" style="min-height: 60vh;">
          <h4 class="discussion-instantane" >
            <mat-icon>person</mat-icon>
            Mes contacts
          </h4>
        
          <p class="mx-4" style="color: gray; font-size: 14px;">Les personnes que vous suivez et qui vous suivent en retour </p>
          <!--<div class="chat-sidebar">
              <div *ngFor="let user of mutualFollowers" (click)="openChatWindow(user)"   class="chatRow">
                  
                  
                      <div class="row  my-1" >
                          <img [src]="user.profilePhotoUrl" alt="{{user.publicName}}" 
                          class="profile-picture2 col-2" [routerLink]="['/postfeed/userprofile', user.uid]">
                          <span class="col-9 my-2 ml-0">{{user.publicName}}</span>
                      </div>
                  
                
              </div>
            </div>-->
            <input type="text" [(ngModel)]="searchTerm" placeholder="Rechercher un contact..." class="search-input">
  
            <div class="chat-sidebar">
              <!-- Barre de Recherche -->
              
            
              <!-- Liste des Utilisateurs Filtrée -->
              <div *ngFor="let user of mutualFollowers | filter: searchTerm" (click)="openChatWindow(user)" class="chatRow">
                <div class="row my-1">
                  <img [src]="user.profilePhotoUrl ? user.profilePhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" alt="{{user.publicName}}" 
                       class="profile-picture2 col-2" 
                       [routerLink]="['/postfeed/userprofile', user.uid]">
                  <span class="col-9 my-2 ml-0">{{user.publicName}}</span>
                </div>
              </div>
            </div>
            
  
            <!-- Fenêtres de chat -->
          <div class="chat-windows">
              <div *ngFor="let chatWindow of openChats" class="chat-window">
              <div class="chat-header">
                  <div class="chatInfo">
                      <img [src]="chatWindow.userData.profilePhotoUrl ? chatWindow.userData.profilePhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" alt="{{chatWindow.userData.publicName}}" class="profile-picture2 col-2" [routerLink]="['/postfeed/userprofile', chatWindow.userData.uid]">
                      <div>
                          <div >{{chatWindow.userData.publicName}}</div>
                          <div ><small style="color: gray;">({{chatWindow.userData.description}})</small></div>
                      </div>
                  </div>
                  
                  <button (click)="closeChatWindow(chatWindow.userData)" class="close-button">X</button> <!-- Bouton pour fermer la fenêtre -->
              </div>
              <!--<div class="chat-messages">
                  <div *ngFor="let message of messages">
                    <span [ngClass]="{'my-message': message.senderId === currentUser.id}">
                      {{message.text}}
                    </span>
                  </div>
                </div>-->
  
                <div class="chat-messages" #messageContainer (scroll)="checkIfScrolledToBottom(chatWindow, messageContainer)">
                  <div *ngFor="let message of chatWindow.messages; let i = index" class="chat-message">
                    <div [ngClass]="{'sent': message.senderId === userData.uid, 'received': message.senderId !== userData.uid}">
                      <img *ngIf="message.imageUrl" [src]="message.imageUrl" alt="Comment image" class="comment-image"  >
                      <div >{{ message.text }}</div>
                      <div>
                        <audio *ngIf="message.audioUrl && message.audioUrl !== ''" controls class="audio-player" #audioPlayer>
                          <source [src]="message.audioUrl"  type="audio/mpeg"> 
                          Votre navigateur ne supporte pas l'élément audio.
                        </audio>
                      </div>
                    
                      
                      <small class="message-time">{{ getMessageFormattedDate(message.timestamp) }}</small>
  
                    </div>
                   
                    
                  </div>
                </div>
             
  
              <div class="chat-input">
                 <!-- Zone d'aperçu -->
    <div class="preview-container" *ngIf="chatWindow.audioBlobUrl || chatWindow.imageBlobUrl">
      <!-- Aperçu de l'audio -->
      <div class="audio-preview" *ngIf="chatWindow.audioBlobUrl">
        <audio controls [src]="chatWindow.audioBlobUrl"></audio>
        <button (click)="removeFile(chatWindow)" class="close-button2">x</button>
      </div>
  
      <!-- Aperçu de l'image -->
      <div class="image-preview " *ngIf="chatWindow.imageBlobUrl">
        <img [src]="chatWindow.imageBlobUrl" alt="Image preview" style="width: 60px; height: 50px;">
        <button (click)="removeFile(chatWindow)" class="close-button2">x</button>
      </div>
    </div>
  
    <!-- Vérifiez si l'enregistrement n'est pas en cours et qu'aucun fichier audio n'est sélectionné -->
    <ng-container *ngIf="!chatWindow.isRecording && !chatWindow.audioBlobUrl; else recordingTemplate">
      <textarea [(ngModel)]="chatWindow.newMessage" 
                class="message-input" 
                placeholder="Écrire un message..." 
                id="messageInput"
                wrap="soft"
                rows="4"
                (keydown)="handleKeydown($event, chatWindow, messageContainer)">
      </textarea>
      
      <!-- Bouton de sélection de fichier -->
      <button mat-button color="warn" class="file-selector-button mt-2" 
              [matMenuTriggerFor]="fileMenu" 
              [hidden]="chatWindow.isRecording || chatWindow.audioBlobUrl">
        <mat-icon>attach_file</mat-icon>
      </button>
  
      <!-- Bouton pour envoyer le message ou enregistrer un audio -->
      <button mat-icon-button class="centered-button" (click)="handleSend(chatWindow, i)">
        <ng-container *ngIf="chatWindow.newMessage && chatWindow.newMessage.trim() !== '' || chatWindow.audioBlobUrl; else micTemplate">
          
          
          <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
            <mat-icon>send</mat-icon>
          </span>
        </ng-container>
        <ng-template #micTemplate>
          
          <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
            <mat-icon (click)="startRecording(chatWindow)">mic</mat-icon>
          </span>
        </ng-template>
      </button>
    </ng-container>
                
                <!-- Template pour l'enregistrement vocal -->
                <ng-template #recordingTemplate style="max-width: 100%; display: flex; border: 1px solid red;">
                  <div class="recording-indicator" [hidden]="!chatWindow.isRecording">
                    <span style="min-width: 70%; margin-left: 35px; margin-right: 30px; color: red;">Enregistrement en cours...</span>
                    
                    <button mat-icon-button
                        (click)="stopRecording(chatWindow)"
                            style="color: rgb(255, 255, 255); background-color: rgb(44, 195, 246); margin-left: 3px; margin-bottom: 9px;" 
                            [ngClass]="{'recording': isRecording}" class="centered-button">
                           
                            <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
                              <mat-icon>stop</mat-icon>
                            </span>
                    </button>
                  </div>
                  <button mat-icon-button class="centered-button" 
                    (click)="handleSend(chatWindow, i)" 
                    *ngIf="chatWindow.audioBlobUrl"
                    style="color: rgb(255, 255, 255); background-color: rgb(44, 195, 246); margin-left: 3px; margin-bottom: 9px;" >
                  <ng-container >
                    
                    
                    <span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
                      <mat-icon>send</mat-icon>
                    </span>
                  </ng-container>
                  
                </button>
                </ng-template>
                <div>
                  <!-- Bouton pour envoyer le message ou enregistrer un audio -->
                
  
                
              
                <mat-menu #fileMenu="matMenu" xPosition="after" yPosition="above"> 
                  <button mat-menu-item (click)="selectFile(chatWindow,'image')">Image</button>
                  <button mat-menu-item (click)="selectFile(chatWindow,'audio')">Audio</button>
                </mat-menu>
                </div>
  
                
  
                
              </div>
  
              
              
              </div>
          </div>
          <!--<button style="width: 100%;">
              <div class="row">
                  <div class="row">
                      <div class="profile-picture col-3">
                          <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                      </div>
                      <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                  </div>             
              </div>
          </button>
          <button style="width: 100%;">
              <div class="row">
                  <div class="row">
                      <div class="profile-picture col-3">
                          <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                      </div>
                      <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                  </div>             
              </div>
          </button>
  
          <button style="width: 100%;">
              <div class="row">
                  <div class="row">
                      <div class="profile-picture col-3">
                          <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                      </div>
                      <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                  </div>             
              </div>
          </button>
  
          <button style="width: 100%;">
              <div class="row">
                  <div class="row">
                      <div class="profile-picture col-3">
                          <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                      </div>
                      <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                  </div>             
              </div>
          </button>
  
          <button style="width: 100%;">
              <div class="row">
                  <div class="row">
                      <div class="profile-picture col-3">
                          <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c" alt="">
                      </div>
                      <h5 class="col-6 mt-2 ml-0">Prenom Nom</h5>
                  </div>             
              </div>
          </button>
          -->
  
          <div class="contact-container" *ngIf="mutualFollowers.length <6">
              <div class="contact-circle">
                
                <img src="https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/lenali.png?alt=media&token=ae3e0c00-4c03-492b-9a5a-444fd11c4e60" alt="">
                
              </div>
              <div class="contact-items">
                <div class="contact-item">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <div class="contact-item">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                  </svg>
                </div>
                <div class="contact-item">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                  </svg>
                </div>
                <div class="contact-item">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </div>
              </div>
            </div>
          
          
          
          
      </div>
      
  </div>
  <!--==============Main Right End==============-->
  </div>
  
  
  
  
  